import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";
import _slicedToArray from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import axios from 'axios';
import http from "@/api/http";
import router from '@/router';
var AUTH_NAME = 'auth'; // 权限数据缓存名

var _process$env = process.env,
    VUE_APP_EC_API = _process$env.VUE_APP_EC_API,
    BASE_URL = _process$env.VUE_APP_GLOBAL_CONFIG,
    NODE_ENV = _process$env.NODE_ENV;
var CACHE_CONFIG = null; // 定义缓存池

export function getAuthStorage() {
  var item = localStorage.getItem(AUTH_NAME);
  return JSON.parse(item);
}
export function setAuthStorage(item) {
  if (!item) return;

  var type = _typeof(item);

  if (type === 'object' || type === 'array') {
    item = JSON.stringify(item);
  }

  localStorage.setItem(AUTH_NAME, item);
} // 清除所有缓存

export function removeAllStorage() {
  localStorage.clear();
  sessionStorage.clear();
  if (window.GLOBAL_CONFIG) delete window.GLOBAL_CONFIG; // 处理掉window的数据
} // 公共设置sessionstorage

export function setSessionStorage(name, data) {
  if (!data) return;

  var type = _typeof(data);

  if (type === 'object' || type === 'array') {
    data = JSON.stringify(data);
  }

  sessionStorage.setItem(name, data);
} // 公共获取sessionstorage

export function getSessionStorage(name) {
  var item = sessionStorage.getItem(name);
  return JSON.parse(item);
} // 公共id获取，主要用在会员体制升级

export function getConfigProjectId(extend) {
  var _getAuthStorage = getAuthStorage(),
      projectId = _getAuthStorage.projectId,
      version = _getAuthStorage.version;

  if (extend) return projectId; // 标记直接返回id

  if (version === 'customized' || !version) return projectId;
  return version;
} // 根据单位id获取全局配置

export function getGlobalConfig() {
  return _getGlobalConfig.apply(this, arguments);
} // 获取项目全局配置，总控制台

function _getGlobalConfig() {
  _getGlobalConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var id, getProject, getMap, _yield$axios$all, _yield$axios$all2, project, map, mapConfig, _mapConfig$attentionC, attentionCity, cityBounds, projectConfig, cityCode, cityName, cityLat, cityLng;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = getConfigProjectId();
            getProject = NODE_ENV === 'production' ? http.getStaticData("".concat(BASE_URL, "project/").concat(id, ".json")) : axios.get("".concat(BASE_URL, "project/").concat(id, ".json"));
            getMap = NODE_ENV === 'production' ? http.getStaticData("".concat(BASE_URL, "map/").concat(id, ".json")) : axios.get("".concat(BASE_URL, "map/").concat(id, ".json"));
            _context.prev = 3;
            _context.next = 6;
            return axios.all([getProject, getMap]);

          case 6:
            _yield$axios$all = _context.sent;
            _yield$axios$all2 = _slicedToArray(_yield$axios$all, 2);
            project = _yield$axios$all2[0];
            map = _yield$axios$all2[1];
            mapConfig = map.data;
            _mapConfig$attentionC = mapConfig.attentionCity, attentionCity = _mapConfig$attentionC === void 0 ? {} : _mapConfig$attentionC, cityBounds = mapConfig.attention_bounds_forecast;
            projectConfig = project.data;

            if (!projectConfig.adcode) {
              cityCode = attentionCity.adcode, cityName = attentionCity.name, cityLat = attentionCity.lat, cityLng = attentionCity.lng;
              projectConfig = Object.assign(projectConfig, {
                cityCode: cityCode,
                cityName: cityName,
                cityLat: cityLat,
                cityLng: cityLng,
                cityBounds: cityBounds // 追加一个最佳城市边界范围

              });
            }

            return _context.abrupt("return", _objectSpread(_objectSpread({}, projectConfig), {}, {
              mapConfig: mapConfig,
              projectId: getConfigProjectId(true)
            }));

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);
            // window.alert(`${id}单位没配置文件`)
            localStorage.clear();
            sessionStorage.clear();
            router.push({
              to: '/login'
            });
            setTimeout(function () {
              router.go(0);
            }, 50);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 17]]);
  }));
  return _getGlobalConfig.apply(this, arguments);
}

export function getInitConfig() {
  return _getInitConfig.apply(this, arguments);
} // 根据用户信息获取配置信息

function _getInitConfig() {
  _getInitConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!CACHE_CONFIG) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", CACHE_CONFIG);

          case 2:
            _context2.next = 4;
            return axios.get('./config.json');

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getInitConfig.apply(this, arguments);
}

export function getUserConfigByToken() {
  return _getUserConfigByToken.apply(this, arguments);
} // 根据用户的cookies刷新时效性

function _getUserConfigByToken() {
  _getUserConfigByToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var _getAuthStorage2, projectId, _getAuthStorage2$vers, version, accesstoken, _yield$http$get, data;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getAuthStorage2 = getAuthStorage(), projectId = _getAuthStorage2.projectId, _getAuthStorage2$vers = _getAuthStorage2.version, version = _getAuthStorage2$vers === void 0 ? 'customized' : _getAuthStorage2$vers, accesstoken = _getAuthStorage2.accesstoken;

            if (!(version === 'customized')) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", false);

          case 3:
            _context3.prev = 3;
            _context3.next = 6;
            return http.get(VUE_APP_EC_API + '/api/v2/passport/getsysversionconfig', {
              companyId: projectId,
              version: version,
              accesstoken: accesstoken
            });

          case 6:
            _yield$http$get = _context3.sent;
            data = _yield$http$get.data;

            if (!data.success) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", data.data || false);

          case 10:
            return _context3.abrupt("return", false);

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](3);
            return _context3.abrupt("return", false);

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 13]]);
  }));
  return _getUserConfigByToken.apply(this, arguments);
}

export function getCookiesTimeliness(params) {
  return http.post(VUE_APP_EC_API + '/api/v2/passport/typhoonwarningexpirecheck', params); // try {
  //     const { data } = await axios.post(VUE_APP_EC_API + '/api/v2/passport/typhoonwarningexpirecheck', params)
  //     return data.success
  // } catch (error) {
  //     const {success, error} = error.response.data
  //     if(!success) {
  //         // 服务端返回状态码
  //     }
  //     return false
  // }
}